export function quotationDateFilter(range, now = new Date()) {
  if (!["7 days", "30 days", "Quarter"].includes(range)) {
    return { durationDate: "", fromDate: "", toDate: "" };
  }
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (range === "Quarter") {
    start.setMonth(Math.floor(start.getMonth() / 3) * 3, 1);
  } else {
    start.setDate(start.getDate() - (range === "7 days" ? 6 : 29));
  }
  // Date-only values preserve the displayed calendar dates in the API's UTC bounds.
  const writtenDate = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  return { durationDate: "custom", fromDate: writtenDate(start), toDate: writtenDate(now) };
}
